'use client';

export type IconName = keyof typeof Icon;

import Cash from '@/assets/icons/Cash.svg';
import Check from '@/assets/icons/Check.svg';
import ChevronDown from '@/assets/icons/ChevronDown.svg';
import ChevronLeft from '@/assets/icons/ChevronLeft.svg';
import ChevronRight from '@/assets/icons/ChevronRight.svg';
import Close from '@/assets/icons/Close.svg';
import Coin from '@/assets/icons/Coin.svg';
import CopyPaste from '@/assets/icons/CopyPaste.svg';
import DataGraphic from '@/assets/icons/DataGraphic.svg';
import Discount from '@/assets/icons/Discount.svg';
import Dollar from '@/assets/icons/Dollar.svg';
import Edit from '@/assets/icons/Edit.svg';
import Filters from '@/assets/icons/Filters.svg';
import Fire from '@/assets/icons/Fire.svg';
import Hamburger from '@/assets/icons/Hamburger.svg';
import Help from '@/assets/icons/Help.svg';
import Home from '@/assets/icons/Home.svg';
import IlottoLogo from '@/assets/icons/IlottoLogo.svg';
import Indicator from '@/assets/icons/Indicator.svg';
import Info from '@/assets/icons/Info.svg';
import Instagram from '@/assets/icons/Instagram.svg';
import Lightning from '@/assets/icons/Lightning.svg';
import ListDone from '@/assets/icons/ListDone.svg';
import Logout from '@/assets/icons/Logout.svg';
import Minus from '@/assets/icons/Minus.svg';
import MustangArrow from '@/assets/icons/MustangArrow.svg';
import Pix from '@/assets/icons/Pix.svg';
import Plus from '@/assets/icons/Plus.svg';
import QrCode from '@/assets/icons/QrCode.svg';
import Rocket from '@/assets/icons/Rocket.svg';
import Rotate from '@/assets/icons/Rotate.svg';
import Shield from '@/assets/icons/Shield.svg';
import SquareEmpty from '@/assets/icons/SquareEmpty.svg';
import SquareFilled from '@/assets/icons/SquareFilled.svg';
import Star from '@/assets/icons/Star.svg';
import SuperStar from '@/assets/icons/SuperStar.svg';
import Support from '@/assets/icons/Support.svg';
import Tag from '@/assets/icons/Tag.svg';
import ThreeChevron from '@/assets/icons/ThreeChevron.svg';
import Ticket from '@/assets/icons/Ticket.svg';
import Tickets from '@/assets/icons/Tickets.svg';
import Trophy from '@/assets/icons/Trophy.svg';
import UserAccount from '@/assets/icons/UserAccount.svg';
import VolumeOff from '@/assets/icons/VolumeOff.svg';
import VolumeOn from '@/assets/icons/VolumeOn.svg';
import Wallet from '@/assets/icons/Wallet.svg';
import WheelBase from '@/assets/icons/WheelBase.svg';
import WheelCenterContainer from '@/assets/icons/WheelCenterContainer.svg';
import WheelPointer from '@/assets/icons/WheelPointer.svg';

export const Icon = {
  DataGraphic: (props: React.SVGProps<SVGSVGElement>) => <DataGraphic {...props} />,
  Tag: (props: React.SVGProps<SVGSVGElement>) => <Tag {...props} />,
  Star: (props: React.SVGProps<SVGSVGElement>) => <Star {...props} />,
  SuperStar: (props: React.SVGProps<SVGSVGElement>) => <SuperStar {...props} />,
  Rocket: (props: React.SVGProps<SVGSVGElement>) => <Rocket {...props} />,
  Cash: (props: React.SVGProps<SVGSVGElement>) => <Cash {...props} />,
  Coin: (props: React.SVGProps<SVGSVGElement>) => <Coin {...props} />,
  Pix: (props: React.SVGProps<SVGSVGElement>) => <Pix {...props} />,
  ThreeChevron: (props: React.SVGProps<SVGSVGElement>) => <ThreeChevron {...props} />,
  SquareEmpty: (props: React.SVGProps<SVGSVGElement>) => <SquareEmpty {...props} />,
  SquareFilled: (props: React.SVGProps<SVGSVGElement>) => <SquareFilled {...props} />,
  Logout: (props: React.SVGProps<SVGSVGElement>) => <Logout {...props} />,
  IlottoLogo: (props: React.SVGProps<SVGSVGElement>) => <IlottoLogo {...props} />,
  ChevronDown: (props: React.SVGProps<SVGSVGElement>) => <ChevronDown {...props} />,
  ChevronRight: (props: React.SVGProps<SVGSVGElement>) => <ChevronRight {...props} />,
  ChevronLeft: (props: React.SVGProps<SVGSVGElement>) => <ChevronLeft {...props} />,
  UserAccount: (props: React.SVGProps<SVGSVGElement>) => <UserAccount {...props} />,
  Home: (props: React.SVGProps<SVGSVGElement>) => <Home {...props} />,
  Close: (props: React.SVGProps<SVGSVGElement>) => <Close {...props} />,
  CopyPaste: (props: React.SVGProps<SVGSVGElement>) => <CopyPaste {...props} />,
  Discount: (props: React.SVGProps<SVGSVGElement>) => <Discount {...props} />,
  Dollar: (props: React.SVGProps<SVGSVGElement>) => <Dollar {...props} />,
  Filters: (props: React.SVGProps<SVGSVGElement>) => <Filters {...props} />,
  Fire: (props: React.SVGProps<SVGSVGElement>) => <Fire {...props} />,
  Help: (props: React.SVGProps<SVGSVGElement>) => <Help {...props} />,
  Indicator: (props: React.SVGProps<SVGSVGElement>) => <Indicator {...props} />,
  Info: (props: React.SVGProps<SVGSVGElement>) => <Info {...props} />,
  Lightning: (props: React.SVGProps<SVGSVGElement>) => <Lightning {...props} />,
  ListDone: (props: React.SVGProps<SVGSVGElement>) => <ListDone {...props} />,
  Minus: (props: React.SVGProps<SVGSVGElement>) => <Minus {...props} />,
  Plus: (props: React.SVGProps<SVGSVGElement>) => <Plus {...props} />,
  QrCode: (props: React.SVGProps<SVGSVGElement>) => <QrCode {...props} />,
  Rotate: (props: React.SVGProps<SVGSVGElement>) => <Rotate {...props} />,
  Shield: (props: React.SVGProps<SVGSVGElement>) => <Shield {...props} />,
  Tickets: (props: React.SVGProps<SVGSVGElement>) => <Tickets {...props} />,
  Trophy: (props: React.SVGProps<SVGSVGElement>) => <Trophy {...props} />,
  Hamburger: (props: React.SVGProps<SVGSVGElement>) => <Hamburger {...props} />,
  Check: (props: React.SVGProps<SVGSVGElement>) => <Check {...props} />,
  WheelBase: (props: React.SVGProps<SVGSVGElement>) => <WheelBase {...props} />,
  Ticket: (props: React.SVGProps<SVGSVGElement>) => <Ticket {...props} />,
  WheelPointer: (props: React.SVGProps<SVGSVGElement>) => <WheelPointer {...props} />,
  Support: (props: React.SVGProps<SVGSVGElement>) => <Support {...props} />,
  WheelCenterContainer: (props: React.SVGProps<SVGSVGElement>) => (
    <WheelCenterContainer {...props} />
  ),
  Edit: (props: React.SVGProps<SVGSVGElement>) => <Edit {...props} />,
  MustangArrow: (props: React.SVGProps<SVGSVGElement>) => <MustangArrow {...props} />,
  Wallet: (props: React.SVGProps<SVGSVGElement>) => <Wallet {...props} />,
  VolumeOn: (props: React.SVGProps<SVGSVGElement>) => <VolumeOn {...props} />,
  VolumeOff: (props: React.SVGProps<SVGSVGElement>) => <VolumeOff {...props} />,
  Instagram: (props: React.SVGProps<SVGSVGElement>) => <Instagram {...props} />,
};

export const IconDynamic = (name: IconName, props?: React.SVGProps<SVGSVGElement>) => {
  const IconComponent = Icon[name];
  if (!IconComponent) return null;

  return <IconComponent {...props} />;
};
